import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService, PageChangedEvent } from 'ngx-bootstrap';
import { ModalReasonRejectionComponent } from 'app/views/modales/request/holiday/modal-reason-rejection.component';
import { AppConfig } from 'app/app.config';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { HolidayService } from '../holiday.service';
import { IDtoEmployeeFilter } from 'app/shared/models/request/holiday/dto-employee-filter.model';
import { SecurityService } from 'app/shared/services/security.service';
import { ISelect } from 'app/shared/models/select.model';
import { IDtoHoliday } from 'app/shared/models/request/holiday/dto-holiday.model';
import { KeyedCollection } from 'app/shared/models/employee/dto-employee.model';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalReasonCancelComponent } from 'app/views/modales/request/holiday/modal-reason-cancel.component';
import { IMyDateModel } from 'angular-mydatepicker';
import { ExcelService } from '../excel.service';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../../security/identity.service';

@Component({
    selector: 'app-holiday-approval',
    styleUrls: ['holiday-approval.style.scss'],
    templateUrl: 'holiday-approval.template.html'
})
export class HolidayApprovalComponent implements OnDestroy, OnInit {
    @ViewChild('addSwal', { static: false }) private addSwal: SwalComponent;
    @ViewChild('coverHolidaySwal', { static: false }) private coverHolidaySwal: SwalComponent;
    /**Variables */
    private showRoles: any;
    private zones: any;
    private marks: any;
    public nav: any;
    private request: IDtoHoliday;
    /**Modales */
    private modalRef: BsModalRef;
    /**Catalogos */
    private catalogRequestStatus: ISelect[];
    /**Pagination */
    private page: number;
    private itemsPage: number = 5;
    private listRequestFilter: IDtoHoliday[] = [];
    private listRequestFilterNameEmployee: IDtoHoliday[] = [];
    private listRequestTotal: IDtoHoliday[] = [];
    private status: number;
    private configModal = {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
    };
    private employeeIniId: string;
    private profile: string;
    private locale: string = 'es';
    private start: IMyDateModel;
    private end: IMyDateModel;
    public constructor(private modalService: BsModalService
        , private configGeneral: AppConfig
        , private holidayService: HolidayService
        , private securityService: SecurityService
        , private configurationService: ConfigurationService
        , private spinner: NgxSpinnerService
        , private excelService: ExcelService
        , private identityService: IdentityService) {
        this.nav = document.querySelector('nav.navbar');
        this.showRoles = this.securityService.getUserRolesStorage();
        this.profile = this.securityService.getProfileStorage('HolidayApproval');
        if (this.showRoles !== '') {
            this.employeeIniId = this.showRoles.employeeId;
            this.zones = this.showRoles.listZones === undefined ? [] : this.showRoles.listZones;
            this.marks = this.showRoles.listMarks === undefined ? [] : this.showRoles.listMarks;
        }
    }

    ngOnInit(): any {
        this.nav.className += ' white-bg';
        if (this.configurationService.isReady) {
            this.getCatalogRequestStatus();
            this.getNewRequest();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.getCatalogRequestStatus();
                this.getNewRequest();
            });
        }
        let d: Date = new Date();
        this.start = { isRange: false, singleDate: { jsDate: d }, dateRange: null };
        this.end = { isRange: false, singleDate: { jsDate: d }, dateRange: null };
    }
    public ngOnDestroy(): any {
        this.nav.classList.remove('white-bg');
    }
    private generateExcel() {
        if (this.listRequestTotal != undefined) {
            this.excelService.generateExcelHolidays(this.listRequestTotal);
        }
    }
    private getCatalogRequestStatus(): void {
        this.holidayService.getCatalogRequestStatus().subscribe((res) => {
            this.catalogRequestStatus = res;
        });
    }
    private getNewRequest(): void {
        this.spinner.show();
        const list = this.filters(0);
        this.holidayService.getHolidaysRequest(list).subscribe((res) => {
            if (res.isCorrect) {
                this.listRequestTotal = res.data as IDtoHoliday[];
                this.listRequestFilterNameEmployee = this.listRequestTotal;
                this.showItems(this.listRequestFilterNameEmployee);
            }
            this.spinner.hide();
        });
    }
    private getApprovedRequest(): void {
        this.spinner.show();
        const list = this.filters(1);
        this.holidayService.getHolidaysRequest(list).subscribe((res) => {
            if (res.isCorrect) {
                this.listRequestTotal = res.data as IDtoHoliday[];
                this.listRequestFilterNameEmployee = this.listRequestTotal;
                this.showItems(this.listRequestFilterNameEmployee);
            }
            this.spinner.hide();
        });
    }
    private getRejectedRequest(): void {
        this.spinner.show();
        const list = this.filters(2);
        this.holidayService.getHolidaysRequest(list).subscribe((res) => {
            if (res.isCorrect) {
                this.listRequestTotal = res.data as IDtoHoliday[];
                this.listRequestFilterNameEmployee = this.listRequestTotal;
                this.showItems(this.listRequestFilterNameEmployee);
            }
            this.spinner.hide();
        });
    }
    private getCancelRequest(): void {
        this.spinner.show();
        const list = this.filters(3);
        this.holidayService.getHolidaysRequest(list).subscribe((res) => {
            if (res.isCorrect) {
                this.listRequestTotal = res.data as IDtoHoliday[];
                this.listRequestFilterNameEmployee = this.listRequestTotal;
                this.showItems(this.listRequestFilterNameEmployee);
            }
            this.spinner.hide();
        });
    }
    private filters(status: number): IDtoEmployeeFilter {
        const list = {} as IDtoEmployeeFilter;
        list.statusId = status;
        list.employeeId = this.employeeIniId;
        list.profile = this.profile;
        list.startDate = this.getDate(this.start);
        list.endDate = this.getDate(this.end);
        this.status = status;
        return list;
    }
    private openModalReasonRejection(request: IDtoHoliday): void {
        const initialState = {
            title: 'Motivo de rechazo',
            request: request
        };
        this.modalRef = this.modalService.show(ModalReasonRejectionComponent
            , Object.assign({ initialState }
                , this.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                this.getNewRequest();
            }
        });
    }
    private openModalReasonCancel(request: IDtoHoliday): void {
        const initialState = {
            title: 'Motivo de cancelación',
            request: request
        };
        this.modalRef = this.modalService.show(ModalReasonCancelComponent
            , Object.assign({ initialState }
                , this.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                this.getApprovedRequest();
            }
        });
    }
    private isCoverHoliday(request: IDtoHoliday): void {
        this.request = request;
        this.coverHolidaySwal.title = 'Indique si el periodo vacacional a aprobar requiere ser cubierto o no.';
        this.coverHolidaySwal.show();
    }
    private submitForm(): void {
        this.addSwal.title = 'Seguro que desea aprobar el periodo vacacional seleccionado.';
        this.addSwal.show();
    }
    private yesRequired(): void {
        this.request.coverHoliday = true;
        this.submitForm();
    }
    private noRequired(): void {
        this.request.coverHoliday = false;
        this.submitForm();
    }
    private update(): void {
        this.spinner.show();
        this.request.status = 1;
        this.holidayService.updateHoliday(this.request)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        this.getNewRequest();
                        this.addModuleLog(this.request.id)
                        this.spinner.hide();
                    } else {
                        this.spinner.hide();
                    }
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private showItems(data: IDtoHoliday[]): void {
        const startItem = (1 - 1) * this.itemsPage;
        const endItem = 1 * this.itemsPage;
        this.listRequestFilter = data.slice(startItem, endItem);
        this.page = 1;
    }
    private pageChanged(event: PageChangedEvent): void {
        const startItem = (event.page - 1) * event.itemsPerPage;
        const endItem = event.page * event.itemsPerPage;
        this.listRequestFilter = this.listRequestFilterNameEmployee.slice(startItem, endItem);
    }
    private getDate(event?: IMyDateModel) {
        if (event === undefined) {
            return null;
        }
        return event.singleDate.jsDate;
    }
    private addModuleLog(id: number): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Holidays';
        dto.module = 'holidayApproval';
        dto.action = 'approved';
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
    private filterNameEmployee(name: string): void {
      let result: IDtoHoliday[] = [];
      const uppercaseName = name.toUpperCase();
      if (name != ''){
        result =  this.listRequestTotal.filter(a => a.employeeName.includes(uppercaseName));
        this.listRequestFilterNameEmployee = result;
      }
      else{
        result = this.listRequestTotal;
        this.listRequestFilterNameEmployee = result;
      }
      this.showItems(result);
    }
}
